// extracted by mini-css-extract-plugin
export var border = "_20-8";
export var brand = "_20-t";
export var button = "_20-l";
export var center = "_20-a";
export var centered = "_20-6";
export var closeButton = "_20-c";
export var disabledWrapper = "_20-m";
export var error = "_20-p";
export var extraLarge = "_20-4";
export var extraSmall = "_20-1";
export var fill = "_20-i";
export var footer = "_20-h";
export var footerAction = "_20-j";
export var footerButtons = "_20-k";
export var header = "_20-7";
export var headerWithClose = "_20-d";
export var icon = "_20-o";
export var info = "_20-s";
export var inline = "_20-9";
export var large = "_20-3";
export var main = "_20-e";
export var modal = "_20-0";
export var nearFull = "_20-5";
export var neutral = "_20-u";
export var noPadding = "_20-g";
export var none = "_20-v";
export var scrollable = "_20-f";
export var small = "_20-2";
export var success = "_20-r";
export var tight = "_20-n";
export var titleIcon = "_20-b";
export var warn = "_20-q";